import React from "react";
import VerticalPage from "@/verticals/VerticalPage";
import { locationData } from "@/verticals/verticalData";

export default function LocationPage() {
  return <VerticalPage data={locationData} />;
}
